import React from 'react';
import {LauncherComponentBase} from '../../base-components/launcher-component-base';
import {createStyles, Theme, withStyles, fade} from "@material-ui/core/styles";
import {WithStyles} from '@material-ui/core'
import {observer} from 'mobx-react';
import SearchIcon from '@material-ui/icons/Search';
import {LauncherSearchResultComponent} from '../search-result/launcher-search-result.component';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ClearSearchIcon from '@material-ui/icons/Clear';
import Input from '@material-ui/core/Input';


const styles = (theme: Theme) => createStyles ({
    inputRoot: {
        color: 'inherit',
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(3),
            width: 'auto',
        },
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 1),
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: 200,
        },
    }
});

export interface AppSearchBoxComponentProps extends WithStyles<typeof styles>{

}

export const LauncherSearchBoxComponent = withStyles(styles)(
  observer(
      class extends LauncherComponentBase<AppSearchBoxComponentProps> {

          private readonly _searchBoxElementRef;
          constructor(props: AppSearchBoxComponentProps) {
              super(props);
              this._searchBoxElementRef = React.createRef();
          }

          private _handleChange = (event) => {
            this.services.search.search(event.currentTarget.value);
          };

          private _clearSearch = () => {
              this.services.search.clearSearch();
          };

          private _renderSearchIcon() {
              if((this.services.search.currentSearchText || '').length === 0) {
                  return (<SearchIcon/>);
              } else {
                  return (<Tooltip title='Cancel search'>
                      <IconButton onClick={this._clearSearch} size='small' >
                          <ClearSearchIcon/>
                      </IconButton>
                  </Tooltip>);
              }

          }

          render() {
              const popperId = 'launcher-search-result';
              return (

                  <div className={this.props.classes.search}>
                      <Input
                          disableUnderline={true}
                          placeholder={this.services.search.searchHintText}
                          classes={{
                              root: this.props.classes.inputRoot,
                              input: this.props.classes.inputInput,
                          }}
                          startAdornment={this._renderSearchIcon()}
                          aria-describedby={popperId}
                          ref={this._searchBoxElementRef}
                          onChange={this._handleChange}
                          value={this.services.search.currentSearchText}
                      />


                      <LauncherSearchResultComponent searchBoxElementRef={this._searchBoxElementRef}
                                                     popperId={popperId}/>


                  </div>
              )
          }
      }
  )
);
